import { useQuery } from 'react-query';
import { useAppContext } from '../../context/useAppContext';
import companyApplicationService from '../../services/AppGallery/companyApplicationService';
import config from '../../appConfig';

const useAppAccessCheck = () => {
  const {
    state: { authorized },
  } = useAppContext();

  const {
    data: appAccessCheck,
    isLoading,
    isFetching,
  } = useQuery('appAccessCheck', () => companyApplicationService.checkApplicationAccess(config.trackingAppId!), {
    enabled: authorized,
    refetchOnMount: false,
    refetchOnWindowFocus: true,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 0,
  });

  return {
    isLoading: isLoading || (!appAccessCheck && isFetching),
    accessGranted: appAccessCheck?.accessGranted,
  };
};

export default useAppAccessCheck;
